<!-- TEMPLATE -->
<template>
  <div class='my-organization-class'>
    <dean-two-column-layout title="Mijn organisatie">
      <dean-section-title-item
          v-if="$store.getters.getUser.privileges.includes('view-partner')"
          :icon='saveIcon'
          slot="title-items"
          :content="true"
          :large="true"
          @click.native="processOrganization"
      >
        Opslaan
      </dean-section-title-item>
      <div class="column" slot="left">
        <dean-section-divider>Algemeen</dean-section-divider>
        <dean-form-row id="kvkNumber" v-model="organization.kvkNumber" label="KvK-nummer"
                       :disabled="!$store.getters.getUser.privileges.includes('view-partner')"/>
        <dean-form-row id="name" v-model="organization.name" label="naam" :required-field="true"
                       :warning="$v.organization.name.$error"
                       @focus="$v.organization.name.$touch()"
                       :disabled="!$store.getters.getUser.privileges.includes('view-partner')"/>
        <dean-select-form-row placeholder="Kies een bedrijfsvorm" label='Bedrijfsvorm klant'
                              :options='personTypes'
                              :value='currentType' id="bedrijfsvorm"
                              @input='personTypeFieldChanged'
                              :clearable="$store.getters.getUser.privileges.includes('view-partner')"
                              :disabled="!$store.getters.getUser.privileges.includes('view-partner')"/>
        <dean-form-row id="email" v-model="organization.email" label="e-mail" :required-field="true"
                       :warning="$v.organization.email.$error"
                       @focus="$v.organization.email.$touch()"
                       :disabled="!$store.getters.getUser.privileges.includes('view-partner')"/>
        <dean-form-row id="phoneNumber" v-model="organization.phoneNumber"
                       label="telefoonnummer"
                       :disabled="!$store.getters.getUser.privileges.includes('view-partner')"/>
        <dean-form-row id="generic.website" v-model="organization.website" label="website"
                       :disabled="!$store.getters.getUser.privileges.includes('view-partner')"/>
      </div>
      <div class="column" slot="right">
        <dean-section-divider>Adresgegevens</dean-section-divider>
        <dean-form-row id="address.street" v-model="organization.address.street" label="straat"
                       :required-field="true"
                       :warning="$v.organization.address.street.$error"
                       @focus="$v.organization.address.street.$touch()"
                       :disabled="!$store.getters.getUser.privileges.includes('view-partner')"/>
        <dean-form-row id="address.houseNumber" v-model="organization.address.houseNumber"
                       label="huisnummer"
                       :required-field="true" :warning="$v.organization.address.houseNumber.$error"
                       @focus="$v.organization.address.houseNumber.$touch()"
                       :disabled="!$store.getters.getUser.privileges.includes('view-partner')"/>
        <dean-form-row id="address.houseNumberExtension" v-model="organization.address.houseNumberExtension"
                       label="toevoeging"
                       :disabled="!$store.getters.getUser.privileges.includes('view-partner')"/>
        <dean-form-row id="address.postalCode" v-model="organization.address.postalCode" label="postcode"
                       :required-field="true"
                       :warning="$v.organization.address.postalCode.$error"
                       @focus="$v.organization.address.postalCode.$touch()"
                       :disabled="!$store.getters.getUser.privileges.includes('view-partner')"/>
        <dean-form-row id="address.city" v-model="organization.address.city" label="plaats"
                       :required-field="true"
                       :warning="$v.organization.address.city.$error"
                       @focus="$v.organization.address.city.$touch()"
                       :disabled="!$store.getters.getUser.privileges.includes('view-partner')"/>
      </div>
    </dean-two-column-layout>
  </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
// VUE
import {Component, Vue} from 'vue-property-decorator';
import vSelect from 'vue-select';
import axios from 'axios';

import {
  deanAlertDialog,
  deanSectionDivider,
  deanSectionTitle,
  deanSectionTitleItem,
  saveIcon,
} from '@deanone/dean-components';
import DeanFormRow from '@/components/deanComponents/deanFormRow.vue';
import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
import deanInputSelect from '@/components/deanComponents/deanInputSelect.vue';
import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import deanSectionTitleRemoveRestore from '@/components/deanComponents/deanSectionTitleRemoveRestore.vue';
import {validationMixin} from 'vuelidate';
import {required, email} from 'vuelidate/lib/validators';
import {Validations} from 'vuelidate-property-decorators';
import {createNotification} from '@/mixins/validations';
import {postalCode} from '@/mixins/validators';
import sideMenuProfileMixin from '@/mixins/sideMenuProfileMixin';
import {mixins} from 'vue-class-component';

@Component({
  components: {
    deanSectionTitleRemoveRestore,
    DeanSelectFormRow,
    deanAlertDialog,
    DeanTwoColumnLayout,
    deanInputSelect,
    DeanFormRow,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    vSelect,
  },
  mixins: [validationMixin],
})

export default class Details extends mixins(sideMenuProfileMixin) {
  public organization: {
    kvkNumber: any,
    name: any,
    type: {
      id: any,
      code: any,
      name: any,
    },
    email: any,
    phoneNumber: any,
    website: any,
    address: {
      street: any,
      houseNumber: any,
      houseNumberExtension: any,
      postalCode: any,
      city: any,
    },
  } = {
    kvkNumber: null,
    name: null,
    type: {
      id: null,
      code: null,
      name: null,
    },
    email: null,
    phoneNumber: null,
    website: null,
    address: {
      street: null,
      houseNumber: null,
      houseNumberExtension: null,
      postalCode: null,
      city: null,
    },
  };
  public personTypes: Array<{ value: any, label: any }> = [];
  public urlParams: any = {};
  public saveIcon: object = saveIcon;

  // COMPUTED
  @Validations()
  get validations() {
    return {
      organization: {
        name: {required},
        email: {required, email},
        address: {
          street: {required},
          houseNumber: {required},
          postalCode: {required, postalCode},
          city: {required},
        },
      },
    };
  }

  get organizationData() {
    return this.organization;
  }

  get currentType() {
    return this.personTypes.find((personType: any) => {
      return personType.value === this.organization.type?.id;
    });
  }

  public personTypeFieldChanged(field: any) {
    this.organization.type.id = field.value;
  }

  public created() {
    const promises = [];

    this.$store.dispatch('setLoadOverlay', true);

    promises.push(this.getOrganizationInfo());
    promises.push(this.initPersonTypes());

    Promise.all(promises).finally(() => this.$store.dispatch('setLoadOverlay', false));

    this.buildSideMenuProfile();
  }

  public getOrganizationInfo() {
    const url = '/-/trade/api/organization.info';

    return axios.get(url)
        .then(
            (response) => {
              this.organization = response.data;
            },
            (error) => {
              this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
            },
        );
  }

  public processOrganization() {
    const url = '/-/trade/api/organization.update';

    this.$v.$touch();

    if (!this.$v.$invalid) {
      this.$store.dispatch('setLoadOverlay', true);

      axios.post(url, this.organizationData, {
        params: this.urlParams,
      })
          .then(
              (response) => {
                this.$toast(this.$store.state.main.notification.messages.dataSaved);
              },
              (error) => {
                this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
              },
          ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    } else {
      this.$toast(createNotification(this.$v));
    }
  }

  public initPersonTypes() {
    const url = '/-/trade/api/person.types.list';

    axios.post(url).then(
        (response: any) => {
          this.personTypes = [];

          for (const personType of response.data) {
            this.personTypes.push({
              value: personType.id,
              label: personType.name,
            });
          }
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
    );
  }
}
</script>

<!-- STYLE -->

<style lang='scss' scoped>

</style>
